import {
	AssessmentComponent,
	AssessmentEngine,
	AssessmentEngineConfig,
	ComponentVersion,
	ConfigureAssessmentEngine,
	DeviceType,
	InitAssessmentEngine,
} from "@pandas/assessment-engine";
import { platformApi } from "@/services";
export let assessmentEngine: AssessmentEngine;

export async function GetAssessmentEngineSingleton(
	deviceType: DeviceType,
	filterComponents: Array<AssessmentComponent> = [],
	componentVersion: ComponentVersion,
): Promise<AssessmentEngine> {
	const config: AssessmentEngineConfig = {
		enableCache: true,
		// The app's client, so assessment uploads carry the logger every other call has.
		platformApi,
		actor: ["pricing", "webapp", "remote_grader"],
		componentVersion: componentVersion,
	};
	ConfigureAssessmentEngine(config);
	if (!assessmentEngine || deviceType !== selectedDevice) {
		selectedDevice = deviceType;
		assessmentEngine = await InitAssessmentEngine(deviceType, filterComponents);
	}
	return assessmentEngine;
}
let selectedDevice: DeviceType | undefined;
